import React, { useRef, useState, useEffect } from "react";

function ChatTongole() {
  const chatRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const [logo, setLogo] = useState("");
  const [sociallink, setSociallink] = useState([]);
  const [whatsappLink, setWhatsappLink] = useState(null);
  const [dragDistance, setDragDistance] = useState(0);

  const [position, setPosition] = useState({
    x: window.innerWidth - 70,
    y: window.innerHeight - 150,
  });

  const [offset, setOffset] = useState({ x: 0, y: 0 });

  // Fetch logo
  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
        if (!response.ok) throw new Error("Failed to fetch logo");
        const data = await response.json();
        setLogo(`${process.env.REACT_APP_API_URL}/storage/${data[0].mobile_logo}`);
      } catch (error) {
        console.error("Error fetching logo:", error);
      }
    };

    fetchLogo();
  }, []);
  // লাইসেন্স আইডি বসাও নিচে
  useEffect(() => {
    if (window.location.origin === "https://www.chat.com") {
      window.__lc = window.__lc || {};
      window.__lc.license = 19116631;

      (function (n, t, c) {
        function i(n) {
          return e._h ? e._h.apply(null, n) : e._q.push(n);
        }
        var e = {
          _q: [],
          _h: null,
          _v: "2.0",
          on: function () {
            i(["on", c.call(arguments)]);
          },
          once: function () {
            i(["once", c.call(arguments)]);
          },
          off: function () {
            i(["off", c.call(arguments)]);
          },
          get: function () {
            if (!e._h)
              throw new Error("[LiveChatWidget] You can't use getters before load.");
            return i(["get", c.call(arguments)]);
          },
          call: function () {
            i(["call", c.call(arguments)]);
          },
          init: function () {
            var n = t.createElement("script");
            n.async = !0;
            n.type = "text/javascript";
            n.src = "https://cdn.livechatinc.com/tracking.js";
            t.head.appendChild(n);
          },
        };
        !n.__lc.asyncInit && e.init();
        n.LiveChatWidget = n.LiveChatWidget || e;
      })(window, document, [].slice);
    }
  }, []);

  // Fetch social links
//   useEffect(() => {
//     const fetchSocial = async () => {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}/api/sociallink`);
//         const data = await response.json();
//         if (response.ok) setSociallink(data);
//         else console.error("Error fetching social link:", data);
//       } catch (error) {
//         console.error("Error fetching social links:", error);
//       }
//     };

//     fetchSocial();
//   }, []);

  // Set WhatsApp link based on origin
	// useEffect(() => {
	// 	console.log("Social Link:", sociallink);
	// 	if (sociallink && sociallink.length > 0 && sociallink[0]?.whatsapp) {
	// 		const whatsappLink = sociallink[0]?.whatsapp;
	// 		if (whatsappLink) {
	// 			setWhatsappLink(whatsappLink);
	// 		}
	// 	}
	// }, [sociallink]);

	const [show, setShow] = useState(null);
	useEffect(() => {
		let whatsapp = localStorage.getItem("whatsapp");
		let live_chat = localStorage.getItem("liveChat");
		// let intercom = localStorage.getItem("intercom");
		if (live_chat!=='null') {
			setShow('live_chat');
		}else {
			setShow('base_chat');
		}
		setWhatsappLink((whatsapp!=='null') ? whatsapp : null);
	}, [show]);

 

  // Drag Start
  const handleStart = (e) => {
    setDragging(true);
    setDragDistance(0); // Reset drag distance at the start

    const event = e.type === "touchstart" ? e.touches[0] : e;
    const rect = chatRef.current.getBoundingClientRect();

    setOffset({
      x: event.clientX - rect.left,
      y: event.clientY - rect.top,
    });

    // Add global event listeners
    if (e.type === "mousedown") {
      document.addEventListener("mousemove", handleMove);
      document.addEventListener("mouseup", handleEnd);
    } else if (e.type === "touchstart") {
      document.addEventListener("touchmove", handleMove, { passive: false });
      document.addEventListener("touchend", handleEnd);
    }
  };

  const handleMove = (e) => {
    if (!dragging) return;

    const event = e.type === "touchmove" ? e.touches[0] : e;
    e.preventDefault(); // Prevent scrolling on touch devices

    const newX = event.clientX - offset.x;
    const newY = event.clientY - offset.y;

    // Update the drag distance
    const distance = Math.sqrt(
      Math.pow(newX - position.x, 2) + Math.pow(newY - position.y, 2)
    );
    setDragDistance(distance);

    setPosition({ x: newX, y: newY });
  };

  const handleEnd = (e) => {
    // Prevent link click if dragging occurred
    if (dragDistance > 10) {
      e.preventDefault();
    }

    setDragging(true);

    // Remove global event listeners
    document.removeEventListener("mousemove", handleMove);
    document.removeEventListener("mouseup", handleEnd);
    document.removeEventListener("touchmove", handleMove);
    document.removeEventListener("touchend", handleEnd);
	};
	
	// Listen for the custom event to open chat
	useEffect(() => {
		window.addEventListener('open_chat', function () {
			handleChatClick();
		});
	}, [show]);

	
	const handleChatClick = (e) => {
		console.log("Chat Clicked!");
		console.log(whatsappLink);
		if (e) {
			e.preventDefault();
		}

		const remoteId = localStorage.getItem("remote_id");
		const username = localStorage.getItem("username");
		
		if (window.Intercom) {
			window.Intercom("show");
		}else if (whatsappLink && whatsappLink.length > 0) {
			console.log("WhatsApp Link:", whatsappLink);
			window.open(whatsappLink, "_blank");
		} else {
			console.log('anw2');
			if (window.anw2) {
				window.anw2.open();
			}
			if (window.LiveChatWidget) {
				console.log('lch');
				window.LiveChatWidget.once("ready", () => {
					if (remoteId && username) {
						window.LiveChatWidget.call("set_customer_data", {
							name: username,
							external_id: remoteId, 
						});
					}
					window.LiveChatWidget.call("maximize");
				});
			}
			if (window.Tawk_API) {
				window.Tawk_API.maximize();
			}
		}
  	};
  
	//   if (!whatsappLink) return null;
	
	// if (show === 'live_chat') {
	// 	console.log("Live Chat is enabled");
	// 	return null;
	// }

	// console.log("Base Chat is enabled");

	return (
	  <>
		<style>{`
			[id^="anw2-launcher-container-"] [id^="anw2-launcher-"]{
				display: none !important;
			}
		`}</style>
	  
    	<a href="#" onClick={handleChatClick}>
			<div
				ref={chatRef}
				className="chat-tongole"
				style={{
				position: "fixed",
				left: `${position.x}px`,
				top: `${position.y}px`,
				cursor: dragging ? "grabbing" : "grab",
				zIndex: 1000,
				width: "50px",
				height: "50px",
				borderRadius: "50%",
				backgroundColor: "#50b08b",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
				}}
				onMouseDown={handleStart}
				onTouchStart={handleStart} >
				<img src={logo} alt="Chat Icon" style={{ width: "26px" }} />
			</div>
		</a >
	</>
  );
}

export default ChatTongole;
